import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const ServiceCard = ({ slug, serviceKey, image }) => {
    const { t } = useLanguage();
    const service = t.services[serviceKey];

    return (
        <Link
            data-testid={`service-card-${slug}`}
            to={`/${slug}`}
            className="group block bg-[#FFFFF3] border border-[#3D3D24]/15 hover:border-[#3D3D24] transition-colors"
        >
            <div className="overflow-hidden aspect-[4/5]">
                <img
                    src={image}
                    alt={`${service.title} Las Vegas - permanent makeup by Wendy Chester at Beauty Ink LV`}
                    className="w-full h-full object-cover bink-img-hover"
                />
            </div>
            <div className="p-6 md:p-7">
                <div className="font-label text-[10px] text-[#D4A95A] mb-2.5">
                    {service.overline}
                </div>
                <h3 className="font-serif text-2xl md:text-3xl text-[#3D3D24] mb-3 leading-tight">
                    {service.title}
                </h3>
                <p className="text-sm text-[#3D3D24]/75 leading-relaxed mb-5 line-clamp-3">
                    {service.subtitle}
                </p>
                <div className="flex items-center gap-2 text-[#3D3D24] font-label text-xs group-hover:text-[#D4A95A] transition-colors">
                    <span>{t.common.viewService}</span>
                    <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </div>
            </div>
        </Link>
    );
};

export default ServiceCard;
